import parse from 'html-react-parser';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent, { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Box,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import '../../assests/css/usStyle.css';
import loanInputDataImg from '../../assests/images/home/loanInputData.svg';
import loanBiometricImg from '../../assests/images/home/loanBiometric.svg';
import loanSuccessImg from '../../assests/images/home/loanSuccess.svg';
import i18n from '../common/i18n';

const HomeNeedLoanSection = () => {
  const matchesMobile = useMediaQuery('(max-width: 1201px)');

  let theme = createTheme({
    palette: {
      magenta: {
        main: '#DF1365',
        contrastText: '#fff',
      },
    },
  });
  theme = responsiveFontSizes(theme);

  const timelineDotStyle = {
    padding: '0px',
    borderStyle: 'hidden',
    margin: '0px',
    backgroundColor: '#F5F5F5',
  };

  const timelineConnectorStyle = {
    backgroundColor: '#FFFFFF',
    width: '3px',
    height: '20px',
  };

  const timelineContentStyle = {
    padding: matchesMobile ? '0px 0px 0px 10px' : '20px 0px 0px 10px',
    alignContent: 'baseline',
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        className="boxNeedLoan lettersWhiteOnly"
        sx={{
          padding: matchesMobile ? '8px 4%' : '24px 20%',
          height: matchesMobile ? '500px' : '600px',
          margin: 'auto',
          marginTop: '16px',
          marginBottom: '16px',
        }}
      >
        <Box className="alignCenter" mt={matchesMobile ? 4 : 10} mb={4}>
          <Typography variant="h3" fontWeight={800}>
            {i18n.homeNeedLoanTitle}
          </Typography>
        </Box>

        <Box style={{
          padding: '30px',
          alignItems: 'center',
          border: '2px groove rgba(255, 255, 255, 0.24)',
          backgroundColor: 'rgba(255, 255, 255, 0.25)',
          borderRadius: '50px',
        }}
        >
          <Timeline sx={{ [`& .${timelineOppositeContentClasses.root}`]: { flex: 0, padding: 0 } }}>

            <TimelineItem>
              <TimelineOppositeContent />
              <TimelineSeparator>
                <TimelineDot style={timelineDotStyle}>
                  <img src={loanInputDataImg} alt="inputData" />
                </TimelineDot>
                <TimelineConnector style={timelineConnectorStyle} />
              </TimelineSeparator>
              <TimelineContent style={timelineContentStyle}>
                <Typography>{i18n.homeNeedLoanInputData}</Typography>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineOppositeContent />
              <TimelineSeparator>
                <TimelineDot style={timelineDotStyle}>
                  <img src={loanBiometricImg} alt="biometric" />
                </TimelineDot>
                <TimelineConnector style={timelineConnectorStyle} />
              </TimelineSeparator>
              <TimelineContent style={timelineContentStyle}>
                <Typography>{i18n.homeNeedLoanBiometric}</Typography>
              </TimelineContent>
            </TimelineItem>

            <TimelineItem>
              <TimelineOppositeContent />
              <TimelineSeparator>
                <TimelineDot style={timelineDotStyle}>
                  <img src={loanSuccessImg} alt="success" />
                </TimelineDot>
              </TimelineSeparator>
              <TimelineContent style={timelineContentStyle}>
                <Typography>
                  {parse(i18n.homeNeedLoanSuccess)}
                </Typography>
              </TimelineContent>
            </TimelineItem>

          </Timeline>
        </Box>

      </Box>
    </ThemeProvider>
  );
};

export default HomeNeedLoanSection;
